// @ts-nocheck

import { addDays, subDays } from "date-fns";
import en from "date-fns/locale/en-GB";
import { forwardRef } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ClearInputButton from "../../UI/ClearInputButton";
import { getFormattedDate } from "../../Utils/DateUtils";
import styles from "./styled.module.scss";

interface IDateSelector {
  handleGetDateStart: (date: string) => void;
  handleGetDateStop: (date: string) => void;
  dateStart: string;
  dateStop?: string | null;
  cleanable?: boolean;
  dateRange?: number | null;
}

interface IExampleCustomInputProps {
  value?: string;
  onClick?: () => void;
  placeholder?: string;
}

registerLocale("en", en);
const DateSelector = ({
  handleGetDateStart,
  handleGetDateStop,
  dateStart,
  dateStop = null,
  cleanable = true,
  dateRange = null,
}: IDateSelector) => {
  const ExampleCustomInput = forwardRef<
    HTMLInputElement,
    IExampleCustomInputProps
  >(({ value, onClick, placeholder }, ref) => (
    <input
      className={styles.styled_data_picker}
      onClick={onClick}
      ref={ref}
      value={value}
      placeholder={placeholder}
      readOnly
    />
  ));

  const maxDate = dateRange
    ? dateStart
      ? new Date(
          Math.min(
            addDays(new Date(dateStart), dateRange).getTime(),
            new Date().getTime(),
          ),
        )
      : new Date()
    : null;

  const minDate =
    dateRange && dateStop ? subDays(new Date(dateStop), dateRange) : null;

  return (
    <div className={styles.date_filter_block}>
      <div className={styles.date_input}>
        <DatePicker
          onChange={(date: Date) => {
            if (date) {
              handleGetDateStart(getFormattedDate(date));
            }
          }}
          selected={dateStart.length ? new Date(dateStart) : null}
          customInput={<ExampleCustomInput />}
          placeholderText={"Start date"}
          closeOnScroll={true}
          dateFormat="yyyy-MM-dd"
          maxDate={
            dateStop && dateStop.length ? new Date(dateStop) : new Date()
          }
          locale="en"
          minDate={minDate}
        />
        {!!dateStart.length && cleanable && (
          <ClearInputButton
            onClick={() => {
              handleGetDateStart("");
            }}
          />
        )}
      </div>
      <div className={styles.date_input}>
        <DatePicker
          onChange={(date: Date) => {
            if (date) {
              handleGetDateStop(getFormattedDate(date));
            }
          }}
          selected={dateStop ? new Date(dateStop) : null}
          customInput={<ExampleCustomInput />}
          placeholderText={"End date"}
          closeOnScroll={true}
          dateFormat="yyyy-MM-dd"
          minDate={dateStart ? new Date(dateStart) : null}
          locale="en"
          maxDate={maxDate}
        />
        {!!dateStop && !!dateStop.length && cleanable && (
          <ClearInputButton
            onClick={() => {
              handleGetDateStop("");
            }}
          />
        )}
      </div>
    </div>
  );
};

export default DateSelector;
